export default "__VITE_ASSET__CQk0Cj7q__"